import React from "react";
import DirectoryTable from "@/components/DirectoryTable";
import { useAuth } from "@/context/AuthContext";
import { hasRole } from "@/lib/utils";

const FIELDS = [
  { name: "name", label: "Client Name", required: true },
  { name: "primary_contact", label: "Primary Contact Person" },
  { name: "email", label: "Contact Email", type: "email" },
  { name: "phone", label: "Phone" },
  { name: "notes", label: "Notes", type: "textarea" },
];

const COLUMNS = [
  { key: "name", label: "Client Name" },
  { key: "primary_contact", label: "Primary Contact" },
  { key: "email", label: "Email" },
  { key: "phone", label: "Phone" },
];

export default function AdminClients() {
  const { user } = useAuth();
  return (
    <DirectoryTable
      title="Clients"
      description="Master list of client accounts. BD selects from this list on Step 1 instead of re-typing details on every program."
      endpoint="/clients"
      columns={COLUMNS}
      fields={FIELDS}
      canWrite={hasRole(user, "bd")}
      editable
    />
  );
}
